/**
 * Mixin de Paginación y Búsqueda
 *
 * Proporciona funcionalidad de paginación, búsqueda y filtrado de datos para componentes Vue.
 *
 * @mixin paginacionMixin
 *
 * @property {number} pagina - Número de página actual (por defecto: 1)
 * @property {number} itemsPorPagina - Cantidad de elementos por página (por defecto: 10, -1 para mostrar todos)
 * @property {string} search - Término de búsqueda para filtrar datos (por defecto: '')
 *
 * @computed {Array} datosFiltrados - Datos filtrados según el término de búsqueda en todos los campos
 * @computed {number} totalItemsFiltrados - Total de elementos después de aplicar filtros
 * @computed {Array} itemsPaginados - Elementos paginados según la página actual e items por página
 *
 * @method actualizarPagina(nuevaPagina) - Actualiza el número de página actual
 * @method actualizarItemsPorPagina(cantidad) - Actualiza la cantidad de items por página y reinicia en página 1
 *
 * @requires datosParaPaginar - Propiedad que debe ser proporcionada por el componente que use este mixin
 */
export const paginacionMixin = {
  data() {
    return {
      pagina: 1,
      itemsPorPagina: 10,
      search: '',
    };
  },

  computed: {
    datosFiltrados() {
      const datos = this.datosParaPaginar;
      if (!this.search) return datos || [];
      const searchLower = this.search.toLowerCase();
      return (datos || []).filter(item =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(searchLower)
        )
      );
    },

    totalItemsFiltrados() {
      return this.datosFiltrados.length;
    },

    itemsPaginados() {
      if (this.itemsPorPagina === -1) return this.datosFiltrados;
      const inicio = (this.pagina - 1) * this.itemsPorPagina;
      const fin = inicio + this.itemsPorPagina;
      return this.datosFiltrados.slice(inicio, fin);
    },
  },

  watch: {
    search() {
      this.pagina = 1;
    },
    datosParaPaginar() {
      this.pagina = 1;
    },
  },

  methods: {
    actualizarPagina(nuevaPagina) {
      this.pagina = nuevaPagina;
    },
    actualizarItemsPorPagina(cantidad) {
      this.itemsPorPagina = cantidad;
      this.pagina = 1;
    },
  },
};
